<template>
  <custom-modal
    class="custom-modal__extended"
    id="pilot-validity-modal"
    ref="pilotValidityModalRef"
    v-b-modal.modal-center
    :title="$t('lblWizarAlert')"
    @accept="() => {}"
  >
    <div class="py-2 px-2 font-14 text-left color-black border-bottom">
      <p>{{ $t('CertificationEvidenceReminder') }}</p>
    </div>
    <template #footer>
      <div class="d-flex align-items-center justify-content-center pb-3">
        <action-button
          class="btn-success px-4 py-2"
          :text="$t('Understood')"
          i="far fa-check-circle"
          @click="$emit('close')"
        />
      </div>
    </template>
  </custom-modal>
</template>

<script>
//libs
import ActionButton from 'ActionButton';

//common components
import { CustomModal } from '@/components/common';

export default {
  name: 'CertificationEvidenceReminderModal',
  components: {
    ActionButton,
    CustomModal,
  },
  methods: {
    showModal() {
      this.$refs.pilotValidityModalRef.showModal();
    },
    hideModal() {
      this.$refs.pilotValidityModalRef.hideModal();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';

.custom-modal__extended {
  ::v-deep .modal-dialog {
    max-width: 500px !important;
  }
}

.text-container {
  height: 363px;
  overflow: auto;
}
</style>
